import React, { useEffect, useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/styles';
import { Grid, Button, Divider } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import GroupIcon from '@material-ui/icons/Group';
import BusinessCenterIcon from '@material-ui/icons/BusinessCenter';
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn';
import { Page, Header } from 'components';
import { DownloadFile } from 'actions/sessionActions.js';
import OptOverallDatatable from './components/OptOverallDatatable';
import OptOverallDialog from './components/OptOverallDialog/OptOverallDialog';
import OptOverallDeleteDialog from './components/OptOverallDialog/OptOverallDeleteDialog';
import {
	SetFormState, GetOptOverallsIncidents, ToggleOptOverallDialog,
	ToggleDeleteOptOverallDialog, ExportOptOverallsIncidents
} from '../actions/OptOverallActions';

const useStyles = makeStyles((theme) => ({
	root: {
		padding: theme.spacing(3),
	},
	container: {
		marginTop: theme.spacing(1),
	},
	tabs: {
		marginTop: theme.spacing(1),
	},
	content: {
		marginTop: theme.spacing(1),
	},
}));

const OptOverallTracker = () => {
	const classes = useStyles();
	const dispatch = useDispatch();
	const setFormState = formState => dispatch(SetFormState(formState));
	const formState = useSelector((state) => state.optOverallReducer.formState);
	const userId = useSelector(state => state.session.user.id);
	const role = useSelector(state => state.session.user.role);
	const incidents = useSelector((state) => state.optOverallReducer.incidents);
	const optOverallDialogVisibility = useSelector((state) => state.optOverallReducer.optOverallDialogVisibility);
	const deleteOptOverallDialogVisibility = useSelector((state) => state.optOverallReducer.deleteOptOverallDialogVisibility);

	useEffect(() => {
		if (optOverallDialogVisibility === false && deleteOptOverallDialogVisibility === false) {
			dispatch(GetOptOverallsIncidents(userId, role));
		}
	}, [optOverallDialogVisibility, deleteOptOverallDialogVisibility]);

	const _optOverallDialogClose = (event, reason) => {
		if (reason !== 'backdropClick') {
			dispatch(ToggleOptOverallDialog(false));
		}
	};

	const _optOverallDeleteDialogClose = () => {
		dispatch(ToggleDeleteOptOverallDialog(false));
	};

	useMemo(() => {
		dispatch(GetOptOverallsIncidents(userId, role));
	}, [optOverallDialogVisibility, deleteOptOverallDialogVisibility]);

	const _onCreateOverallIncidentClick = () => {
		dispatch(ToggleOptOverallDialog(true));
		setFormState({
			...formState,
			values: {
				...formState.values,
				cfnOwner: userId
			},
		});
	};

	const _onExportIncidentsClick = () => {
		dispatch(ExportOptOverallsIncidents(userId, role));
	};

	return (
		<Page className={classes.root} title="Tracker">
			<Header module="Modules" view="Overall Optimizations" />
			<Grid className={classes.container} container spacing={3}>
				<Grid item lg={12} xs={12}>
					<Button
						className={classes.agreeButton}
						color="primary"
						onClick={_onCreateOverallIncidentClick}
						variant="contained"
						size="small"
					>
						Create Incident
					</Button>
					<Button
						className={classes.agreeButton}
						// color="primary"
						onClick={_onExportIncidentsClick}
						variant="contained"
						size="small"
					>
						Export Incidents
					</Button>
				</Grid>
			</Grid>
			<Grid className={classes.container} container spacing={3}>
				<Grid item lg={12} xs={12}>
					<OptOverallDatatable className={classes.results} data={incidents} />
					{optOverallDialogVisibility && (
						<OptOverallDialog
							onClose={_optOverallDialogClose}
							open={optOverallDialogVisibility}
						/>
					)}
					{deleteOptOverallDialogVisibility && (
						<OptOverallDeleteDialog
							onClose={_optOverallDeleteDialogClose}
							open={deleteOptOverallDialogVisibility}
						/>
					)}
				</Grid>
			</Grid>
		</Page>

	);
};

export default OptOverallTracker;
